import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import theme from './theme';
import { initGA } from './utils/analytics';

// Google Analytics初期化
// 本番環境でのみ有効になります
// 環境変数から測定IDを取得
initGA(process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-QRWGPE0SM2');

// React Router v7の将来的な変更に対応するための設定
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
NavigationContext.future = {
    v7_startTransition: true,
    v7_relativeSplatPath: true
};

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <App />
                    </BrowserRouter>
                </QueryClientProvider>
            </ThemeProvider>
        </HelmetProvider>
    </React.StrictMode>
); 